import { createSlice } from "@reduxjs/toolkit";
import type { InsurerState, Insurer, InsurerList } from "./type";

const EMPTY_LIST: InsurerList = {
  total: 0,
  page: 1,
  page_size: 10,
  data: [],
};

const initialState: InsurerState = {
  insurerList: null,
  selectedInsurer: null,
  insurer_options: [],
  insurer_service_list: null,
  insurer_service_options: [],
};

const insurerSlice = createSlice({
  name: "insurer",
  initialState,
  reducers: {
    insurerList(state, action: { payload: InsurerState["insurerList"] }) {
      state.insurerList = action.payload;
      state.insurer_options = action.payload
        ? action.payload.data?.map((ins) => ({ value: ins.id, label: ins.name }))
        : [];
    },
    insurerServiceList(state, action: { payload: InsurerState["insurer_service_list"] }) {
      state.insurer_service_list = action.payload;
      state.insurer_service_options = action.payload
        ? action.payload.data?.map((ins) => ({
            value: ins.id,
            label: `${ins.name} - ${ins.path ? `(${ins.path})` : ""} `,
          }))
        : // ? action.payload.data?.map((ins) => ({ value: ins.id, label: `${ins.name} ${ins.execution_type ? `(${ins.execution_type})` : ""} ${ins.sequence ? `-(sequence-${ins.sequence})` : ""}` }))
          [];
    },
    addInsurer(state, action: { payload: Insurer }) {
      if (!state.insurerList) {
        state.insurerList = { ...EMPTY_LIST };
      }
      state.insurerList.data.push(action.payload);
      state.insurerList.total += 1;
    },

    updateInsurer(state, action: { payload: Insurer }) {
      if (!state.insurerList) return;
      state.insurerList.data = state.insurerList.data.map((ins) =>
        ins.id === action.payload.id ? action.payload : ins
      );
      if (state.selectedInsurer?.id === action.payload.id) {
        state.selectedInsurer = action.payload;
      }
    },

    deleteInsurer(state, action: { payload: number }) {
      if (!state.insurerList) return;
      state.insurerList.data = state.insurerList.data.filter((ins) => ins.id !== action.payload);
      state.insurerList.total = Math.max(0, state.insurerList.total - 1);
      if (state.selectedInsurer?.id === action.payload) {
        state.selectedInsurer = null;
      }
    },
    selectedInsurer(state, action: { payload: InsurerState["selectedInsurer"] }) {
      state.selectedInsurer = action.payload;
    },
  },
});

export const {
  insurerList,
  addInsurer,
  updateInsurer,
  deleteInsurer,
  selectedInsurer,
  insurerServiceList,
} = insurerSlice.actions;

export default insurerSlice.reducer;
